import { CCKCulture } from "@type/CCKCulture.type";

export function getCurrentCulture(): CCKCulture {
  const basePath = window.cckBasePath;

  const match = basePath.match(/CostaClick\/([a-z]{2})-([A-Z]{2,3})\//);
  return `${match[1]}-${match[2]}` as CCKCulture;
}
